import * as ajaxErrors from "../error/errorMessages";

export const isXhrFailure = (e) =>
{
  return e.request && e.status !== 200;
}

export const translateXhrError = (e) =>
{
  return ajaxErrors.AjaxErrorTranslator.buildErrorObject(e.status, e.data);
}
